"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationsLookup = exports.ApplicationsEnum = exports.ApplicationsArray = void 0;
exports.ApplicationsArray = [
    'medlemsappen',
    'styreappen',
    'eiendeler',
    'medlemssiden',
    'styreportalen',
    'sentralportalen',
    'programapp',
    'styreportalen_cv',
];
var ApplicationsEnum;
(function (ApplicationsEnum) {
    ApplicationsEnum[ApplicationsEnum["MEDLEMSAPP"] = 0] = "MEDLEMSAPP";
    ApplicationsEnum[ApplicationsEnum["STYREAPP"] = 1] = "STYREAPP";
    ApplicationsEnum[ApplicationsEnum["EIENDELAPP"] = 2] = "EIENDELAPP";
    ApplicationsEnum[ApplicationsEnum["MEDLEMSSIDEN"] = 3] = "MEDLEMSSIDEN";
    ApplicationsEnum[ApplicationsEnum["STYREPORTALEN"] = 4] = "STYREPORTALEN";
    ApplicationsEnum[ApplicationsEnum["SENTRALPORTALEN"] = 5] = "SENTRALPORTALEN";
    ApplicationsEnum[ApplicationsEnum["PROGRAMAPP"] = 6] = "PROGRAMAPP";
    ApplicationsEnum[ApplicationsEnum["STYREPORTALEN_CV"] = 7] = "STYREPORTALEN_CV";
})(ApplicationsEnum = exports.ApplicationsEnum || (exports.ApplicationsEnum = {}));
exports.ApplicationsLookup = {
    medlemsappen: ApplicationsEnum.MEDLEMSAPP,
    styreappen: ApplicationsEnum.STYREAPP,
    eiendeler: ApplicationsEnum.EIENDELAPP,
    medlemssiden: ApplicationsEnum.MEDLEMSSIDEN,
    styreportalen: ApplicationsEnum.STYREPORTALEN,
    sentralportalen: ApplicationsEnum.SENTRALPORTALEN,
    programapp: ApplicationsEnum.PROGRAMAPP,
    styreportalen_cv: ApplicationsEnum.STYREPORTALEN_CV,
};
//# sourceMappingURL=Applications.js.map